import { NALOG_SITE_URL } from '../constants';

export const openNalogSite = () => {
    window.open(NALOG_SITE_URL, '_blank');
};
